module.exports = __webpack_public_path__ + "img/labs1.0181a664.svg";